<script>
  import { createEventDispatcher } from 'svelte';

  import { InlineNotification, Modal } from 'carbon-components-svelte';

  import LoadingSpinner from '../LoadingSpinner.svelte';
  import { deleteFeature } from '../../services';

  export let feature,
    open = false;

  let loading = false,
    resultNotification;

  const dispatch = createEventDispatcher();

  async function deleteLicenseFeature() {
    loading = true;

    try {
      await deleteFeature(feature.id);

      dispatch('close', { id: feature.id });
    } catch (error) {
      console.error('[DeleteFeatureModal] Failed to delete license feature!', error);
      resultNotification = {
        hideCloseButton: false,
        kind: 'error',
        title: 'Error:',
        subtitle: 'Failed to delete license feature! Please try again later.',
      };
    } finally {
      loading = false;
    }
  }

  function onModalClose() {
    dispatch('close');
  }
</script>

<Modal
  danger
  modalHeading="Delete License Feature"
  preventCloseOnClickOutside={true}
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={loading}
  size="sm"
  bind:open
  on:click:button--secondary={onModalClose}
  on:close={onModalClose}
  on:submit={deleteLicenseFeature}
>
  <LoadingSpinner {loading}>
    {#if resultNotification}
      <InlineNotification
        kind={resultNotification.kind}
        lowContrast
        title={resultNotification.title}
        subtitle={resultNotification.subtitle}
      />
    {/if}
    <p>You are about to delete license feature <strong>{feature.name}</strong>.</p>
    <br />
    <p>Are you sure?</p>
  </LoadingSpinner>
</Modal>
